import * as p from '@clack/prompts'
import path from 'node:path'
import type { ListIntegrationsCommandOptions } from '@cli-types/core-engine/commands.js'
import { renderTableRows } from '@cli-utils/terminal.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { resolveConfig } from '@next-adapter/config/resolve-config.js'
import { listAvailableIntegrations } from '@next-adapter/integration-runtime/list-available-integrations.js'

export async function runListIntegrationsCommand(
  options: ListIntegrationsCommandOptions
): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  if (options.json) {
    let installed: Set<string>
    try {
      installed = new Set((await resolveConfig(cwd)).integrations.installed)
    } catch (error) {
      console.error(
        `Error loading config: ${error instanceof Error ? error.message : String(error)}`
      )
      process.exit(1)
    }
    const items = listAvailableIntegrations().map((integration) => ({
      id: integration.id,
      status: installed.has(integration.id) ? 'installed' : 'available',
      kind: integration.kind,
      description: integration.description
    }))
    console.log(JSON.stringify(items, null, 2))
    return
  }

  const config = await resolveConfigOrExit(cwd)
  const installedIntegrations = new Set(config.integrations.installed)

  const rows = listAvailableIntegrations().map((integration) => [
    integration.id,
    installedIntegrations.has(integration.id) ? 'installed' : 'available',
    integration.kind,
    integration.description
  ])

  p.note(renderTableRows(rows).join('\n'), 'BetterStart integrations')
  p.outro(
    `${installedIntegrations.size} installed, ${rows.length - installedIntegrations.size} available`
  )
}
